export class CompPackOrderLessonValues {
    constructor(
        lessonsNr: number,
        lessonWebNr: number,
        lessonArcNr: number,
        lessonDefNr: number,
        lessonTypeNr: number,
        packagePositionNr: number,
        from: string = '',
        to: string = '',
        rentalItemNr: number = -1,
    ) {
        this.lessonNr = lessonsNr;
        this.lessonsNr = lessonsNr;
        this.lessonWebNr = lessonWebNr;
        this.lessonArcNr = lessonArcNr;
        this.lessonDefNr = lessonDefNr;
        this.lessonTypeNr = lessonTypeNr;
        this.packagePositionNr = packagePositionNr;
        this.from = from;
        this.to = to;
        this.rentalItemNr = rentalItemNr;
    }

    /*
     * TODO: get rid of the duality of lessonsNr/lessonNr throughout all TS/C#
     * In the final C# request lessonNr (lesson in singular) is the one that's used.
     */
    lessonNr: number;
    lessonsNr: number;
    lessonWebNr: number;
    lessonArcNr: number;
    lessonDefNr: number;
    lessonTypeNr: number;
    packagePositionNr: number;
    from?: string;
    to?: string;
    rentalItemNr?: number;
}